import { render, staticRenderFns } from "./Periodo.vue?vue&type=template&id=3b86b7c4&scoped=true"
import script from "./Periodo.vue?vue&type=script&lang=js"
export * from "./Periodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b86b7c4",
  null
  
)

export default component.exports